export const environment = {
	api: '/api/',
	production: true,
	name: 'production',
	popUrl: 'https://www.premiumvision.com/PartnerOrderPortal/1/',
	azureClient: '004e799e-b188-4eac-bdf8-8367a17ca1c3/user_impersonation',
	msalConfig: {
		clientId: '004e799e-b188-4eac-bdf8-8367a17ca1c3', 
		authority: 'https://login.microsoftonline.com/8948afa6-51e3-4041-8303-5688ba9c8135', 
		redirectUri: window.location.origin + '/redirect',
		postLogoutRedirectUri: window.location.origin,
	}
};
